import frontendAppAccountMessages from './messages/@openedx/frontend-app-account';
import frontendAppAdminConsoleMessages from './messages/@openedx/frontend-app-admin-console';
import frontendAppAuthnMessages from './messages/@openedx/frontend-app-authn';
import frontendAppCatalogMessages from './messages/@openedx/frontend-app-catalog';
import frontendAppGradebookMessages from './messages/@openedx/frontend-app-gradebook';
import frontendAppInstructorDashboardMessages from './messages/@openedx/frontend-app-instructor-dashboard';
import frontendAppLearnerDashboardMessages from './messages/@openedx/frontend-app-learner-dashboard';
import frontendAppNotificationsMessages from './messages/@openedx/frontend-app-notifications';
import frontendAppProfileMessages from './messages/@openedx/frontend-app-profile';
import frontendBaseMessages from './messages/@openedx/frontend-base';
import paragonMessages from './messages/@openedx/paragon';

export default [
  frontendAppAccountMessages,
  frontendAppAdminConsoleMessages,
  frontendAppAuthnMessages,
  frontendAppCatalogMessages,
  frontendAppGradebookMessages,
  frontendAppInstructorDashboardMessages,
  frontendAppLearnerDashboardMessages,
  frontendAppNotificationsMessages,
  frontendAppProfileMessages,
  frontendBaseMessages,
  paragonMessages,
];
